import React from 'react';
const MessageWithGif = (props) => {
    const { gifUrl, title, text } = props;
    return (React.createElement("div", { className: "message-with-gif" },
        React.createElement("div", { className: "title" }, title),
        React.createElement("div", { className: "text" }, text),
        React.createElement("img", { src: `${gifUrl}`, alt: "gif" })));
};
export default MessageWithGif;
